import { render, staticRenderFns } from "./TopPerformingIcon.vue?vue&type=template&id=4aff7b04&scoped=true"
import script from "./TopPerformingIcon.vue?vue&type=script&lang=js"
export * from "./TopPerformingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff7b04",
  null
  
)

export default component.exports